import $ from 'jquery';
import OccupationGraph from '../components/OccupationGraph';
import AverageDeviation from '../components/AverageDeviation';
require('bootstrap');
require('bootstrap-3-typeahead');

var map, marker;

window.initGoogleMaps = function() {
  if (window.google === undefined) {
    const clientId = process.env.VUE_APP_GOOGLE_MAPS_CLIENT_ID;
    const channel = process.env.VUE_APP_GOOGLE_MAPS_CHANNEL;
    const mapsUrl = `https://maps.googleapis.com/maps/api/js?v=3&client=${clientId}&channel=${channel}&callback=initGoogleMaps`;
    $.getScript(mapsUrl, new Function);
  } else {
    map = new google.maps.Map($('#map')[0], {
      center: { lat: 47.410748, lng: 8.590441599999963 },
      zoom: 15
    });
  }
};

function setupDimensionWatcher() {
  DimensionWatcher.enableParentNotification(
    () => {
      return '100%';
    },
    () => {
      return $('.app-wrapper').height() + 20;
    }
  );
}

function replaceSpecialChars(inputString) {
  if (String.prototype.normalize) {
    return inputString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  return inputString;
}

export default {
  name: 'app',
  data: () => {
    return {
      currentRetirementHome: undefined,
      collapsible: {
        element: null,
        isCollapsed: false
      }
    };
  },

  methods: {
    formattedRetirementHome: function(retirementHome) {
      const careIntensityLevel = parseInt(retirementHome.careIntensity);

      return {
        ...retirementHome,
        careIntensity: this.$t('formatting.careIntensity')[careIntensityLevel]
      };
    },

    showDetails: function(retirementHome) {
      this.currentRetirementHome = this.formattedRetirementHome(retirementHome);

      if (this.collapsible.element) {
        this.$nextTick(() => {
          this.collapsible.element.collapse('hide');
        });
      }
    },

    setupTypeahead: function(jqueryInputElement) {
      const options = {
        source: require('../static/data.json'),
        theme: 'bootstrap4',
        highlighter: function(text, item) {
          return `<span class="dropdown-item-text">
            ${item.name}
            <br>
            <small class="text-muted">${item.address}</small>
          </span>`;
        },
        afterSelect: this.showDetails,
        matcher: function(item) {
          const searchable = replaceSpecialChars(`${item.name} ${item.address} ${item.canton}`.toLowerCase());
          const queryWords = replaceSpecialChars(this.query.toLowerCase()).split(' ');
          return queryWords.every(word => searchable.includes(word));
        },
        displayText: function(item) {
          return `${item.name} ${item.address}`;
        }
      };

      jqueryInputElement.typeahead(options).click(() => jqueryInputElement.val(''));
    },

    setupCollapsible: function(collapsible, collapseButton) {
      this.collapsible.element = collapsible;
      collapsible.on('hide.bs.collapse', () => {
        this.collapsible.isCollapsed = true;
      }).on('show.bs.collapse', () => {
        this.collapsible.isCollapsed = false;
      });
    },

    setMarker: function(position) {
      if (marker)
        marker.setMap(null);

      marker = new google.maps.Marker({
        position,
        map
      });
    }
  },

  computed: {
    graphData: function() {
      return [
        this.currentRetirementHome.occup13,
        this.currentRetirementHome.occup12,
        this.currentRetirementHome.occup14,
        this.currentRetirementHome.occup15,
        this.currentRetirementHome.occup16,
      ].map(stringElement => parseFloat(stringElement));
    },

    showGraph: function() {
      for (var i = 0; i < this.graphData.length - 1; i++) {
        if (this.graphData[i] > 0)
          return true;
      }

      return false;
    }
  },

  watch: {
    currentRetirementHome: function(newValue, oldValue) {
      if (newValue !== undefined) {
        var latLng = new google.maps.LatLng(...newValue.latLong);

        if (!oldValue) {
          this.$nextTick(() => {
            window.map = map;
            google.maps.event.trigger(map, 'resize');
            map.setCenter(latLng);
          });
        } else {
          map.panTo(latLng);
        }

        this.setMarker(latLng);
      }
    }
  },

  mounted: function() {
    this.$nextTick(() => {
      setupDimensionWatcher();
      this.setupTypeahead($('#retirementHomeSearch'));
      initGoogleMaps();

      this.setupCollapsible($('#intro'), $('#collapseIntroButton'));
    });
  },

  components: {
    'occupation-graph': OccupationGraph,
    'deviation': AverageDeviation
  }
};



// WEBPACK FOOTER //
// ./src/app/app.js